import moment from 'moment'

const TIME_FORMAT_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/

export const validateDate = (itemIndex, date, minDate, maxDate, errorSection, allowNull = false) => {
  const parsedDate = moment(new Date(date)).startOf('day')
  const dateInRange = parsedDate.isBetween(minDate, maxDate, undefined, '[]')

  if ((allowNull && date === null) || minDate == null || maxDate == null || dateInRange) {
    return {}
  }

  if (!parsedDate.isValid()) {
    return { [errorSection]: { [itemIndex]: { date: ['invalid'] } } }
  } else if (!dateInRange) {
    return { [errorSection]: { [itemIndex]: { date: ['outside_range'] } } }
  }

  return { [errorSection]: { [itemIndex]: { date: ['invalid'] } } }
}

export const validateTime = (itemIndex, time, errorSection, allowTbc = false) => {
  if ((allowTbc && time === 'TBC') || TIME_FORMAT_REGEX.test(time)) {
    return {}
  }

  return { [errorSection]: { [itemIndex]: { time: ['invalid'] } } }
}
